import React from 'react';
import { SkeletonLine } from '@one-thd/sui-atomic-components';

export const SkeletonHeader = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <>
      <div className="sui-col-span-1 sui-order-1 md:sui-col-span-2 md:sui-order-1 sui-leading-9">
        <div className="sui-flex sui-flex-col sui-justify-center sui-items-start sui-whitespace-nowrap">
          <div className="sui-w-96">
            <SkeletonLine variant="heading" />
          </div>
        </div>
      </div>
      <div className="sui-col-span-1 sui-order-1 sui-my-6">
        <div className="sm:sui-w-32 md:sui-w-96 lg:sui-w-96">
          <SkeletonLine variant="multi" numberOfLines={4} />
        </div>
      </div>
      <div
        className={`sui-col-span-1 md:sui-mt-5 sui-order-3 md:sui-col-span-1  md:sui-order-2 ${
          !isMobile ? 'sui-ml-12' : ''
        }`}
      >
        <div className="sui-flex sui-flex-col lg:sui-gap-2 sm:sui-gap-1">
          <div className="sm:sui-w-32 md:sui-w-96 lg:sui-w-96">
            <SkeletonLine variant="multi" numberOfLines={4} />
          </div>
        </div>
      </div>
    </>
  );
};
